import { Link } from "react-router-dom";

export const DashboardCard = ({ to, testId, icon: Icon, title, description, color = "from-blue-900/60 to-blue-800/40", border = "border-primary/30", highlight = false }) => (
  <Link to={to} data-testid={testId}>
    <div className={`bg-gradient-to-r ${color} border ${border} rounded-xl p-5 flex items-center gap-4 hover:opacity-90 transition-all active:scale-[0.98] cursor-pointer ${highlight ? 'ring-1 ring-primary/40' : ''}`}>
      <div className={`p-3 rounded-xl ${highlight ? 'bg-primary/20' : 'bg-secondary/50'}`}>
        <Icon className={`w-6 h-6 ${highlight ? 'text-primary' : 'text-foreground/70'}`} />
      </div>
      <div className="flex-1">
        <h3 className={`font-semibold ${highlight ? 'text-primary' : 'text-foreground'}`}>{title}</h3>
        <p className="text-sm text-muted-foreground mt-0.5">{description}</p>
      </div>
      <div className="text-muted-foreground">›</div>
    </div>
  </Link>
);
